import Checkbox from '@/components/base/form/input/checkbox';
import { ExpandedText } from '@/features/login/components/consents-section/expanded-text';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import type { FieldError } from 'react-hook-form';

export interface CheckboxProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'required' | 'size'> {
  expandedText?: ReactNode;
  required?: boolean;
  error?: FieldError;
  label: ReactNode;
  testId?: string;
}

export const ConsentCheckbox = ({
  expandedText,
  label,
  testId,
  ...rest
}: CheckboxProps) => {
  return (
    <Checkbox
      {...rest}
      testId={testId}
      label={<ExpandedText text={label} expandedText={expandedText} />}
      labelClassName="flex flex-col !gap-0"
    />
  );
};
